/* eslint-disable */

import type { CountriesLang } from "./types/CountriesLang";

let data: CountriesLang | undefined;

export type { CountriesLang };

export default function CountriesLangFactory(): CountriesLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setCountriesLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/CountriesLangDef").then(({ CountriesLangDef }) => {
      data = CountriesLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/CountriesLangDef").then(({ CountriesLangDef }) => {
      data = CountriesLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/CountriesLangDef").then(({ CountriesLangDef }) => {
      data = CountriesLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/CountriesLangDef").then(({ CountriesLangDef }) => {
      data = CountriesLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

